<template>
  <div id="Profile">
    <div class="image">
      <img class="b-img" :src="user.image_nowtalk|defaultImage" v-if="!user.team && user.image_nowtalk"/>
      <img class="b-img" :src="(user.image||user.image_kakao)|image" v-else-if="user.team"/>
      <img class="b-img" src="@/assets/images/pirate/profile.svg" v-else/>
    </div>
    <div class="content">
      <div class="name-line">
        <div class="name">
          {{name}}
        </div>
        <div class="badge">
          {{user.category}}
          {{user.category&&user.startyear?'∙':''}}
          {{user.startyear}}
        </div>
      </div>
      <div class="date-line">{{created}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Profile',
  props: ['user', 'created'],
  data: function () {
    return {
    }
  },
  filters: {
    image: function (value) {
      return value.replace(/^(?:https?:)/, '')
    },
    defaultImage: function (title) {
      return require('@/assets/images/talk/profile/' + title + '.png')
    }
  },
  computed: {
    name() {
      if (!this.user) {
        return '익명'
      } else if (this.user.nickname) {
        return this.user.nickname
      } else if (this.user.name) {
        return this.user.name
      } else {
        return '익명'
      }
    }
  },
  created() {
  },
  destroyed() {},
  methods: {
  },
}
</script>

<style lang="scss" scoped>
  #Profile {
    .image {
      width: 40px;
      height: 40px;
      border-radius: 100%;
      overflow: hidden;
      background-color: #f6f6f6;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content {
      margin-left: 13px;
      .name-line {
        width: 100%;
        .name {
          margin-top: 2px;
          font-size: 16px;
          font-weight: 900;
          line-height: 1.25;
        }
        .badge {
          font-size: 13px;
          padding: 0px 12px;
          line-height: 24px;
          border-radius: 12px;
          background-color: #f4faff;
          margin-left: 6px;
          font-weight: bold;
          color: #7d8da6;
        }
      }
      .date-line {
        width: 100%;
        font-weight: 700;
        font-size: 13px;
        line-height: 1.54;
        color: #8a94a2;
      }
    }
  }
</style>
